import { TypeCategoryFields, TypeCategoryWithoutUnresolvableLinksResponse } from '@/bb-contentful-types'
import STATIC_CONTENTS from '@/blogBuilder/utils/staticContent'
import { Language } from '@/siteBuilder/locale'

export const getCategoriesValue = (
  categories: TypeCategoryWithoutUnresolvableLinksResponse['fields'][],
  selectedCategory: string,
  lang: Language
) => {
  const categoryIdx = categories.findIndex((category) => category.name.toLowerCase() === selectedCategory.toLowerCase())

  if (categoryIdx !== -1) return categories[categoryIdx].name

  // TODO: looks like this line is not testable due to select cannot select a value that's not in the categories
  /* istanbul ignore next  */
  return STATIC_CONTENTS.ALL[lang]
}
